const isNaN = (value) => {
    return value === '';
};
import { convertToIRCurrency } from '../utils/utils';
const mask = {
    bind(el, binding) {
        let min = binding.value.min;
        let max = binding.value.max;
        el.onInput = function(event) {
            let inputVal = event.target.value.replace(/\D/g, '');
            let inputNum = 0;
            if (inputVal !== '') {
                inputNum = parseInt(inputVal, 10);
            } else {
                inputNum = min;
            }
            if (inputNum > max) {
                inputNum = max;
            }

            event.target.value = convertToIRCurrency(inputNum);
        };
        el.addEventListener('input', el.onInput);
    },
    unbind(el) {
        el.removeEventListener('input', el.onInput);
    },
};

export default mask;